import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class OnePaymentOnCashBasisDocumentError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.payment-list-items.one-payment-on-cash-basis-document');
    }
}
